var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeletebutton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20554",
    "data-name": "Group 20554",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.782,
    height: 26.72,
    viewBox: "0 0 20.782 26.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_90634",
    "data-name": "Path 90634",
    d: "M19.844,3a1.484,1.484,0,0,1,1.484,1.484H24.3a1.484,1.484,0,0,1,0,2.969H6.484a1.484,1.484,0,1,1,0-2.969H9.453A1.484,1.484,0,0,1,10.938,3Z",
    transform: "translate(-5 -3)",
    fill: "#f7f7f7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_90635",
    "data-name": "Path 90635",
    d: "M6,7H23.813V24.813a2.969,2.969,0,0,1-2.969,2.969H8.969A2.969,2.969,0,0,1,6,24.813Zm5.2,2.969a.742.742,0,0,0-.742.742v13.36a.742.742,0,1,0,1.484,0V10.711A.742.742,0,0,0,11.2,9.969Zm7.422,0a.742.742,0,0,0-.742.742v13.36a.742.742,0,1,0,1.484,0V10.711A.742.742,0,0,0,18.618,9.969Z",
    transform: "translate(-4.516 -1.062)",
    fill: "#f7f7f7",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletebutton);
export default __webpack_public_path__ + "static/media/deletebutton.682d31c8030fe6aea26ae8798e1b41dc.svg";
export { ForwardRef as ReactComponent };